/** One of the redesigned policy page's four areas, each with its own URL under /policies/:policyId. */
export type PolicySection = 'details' | 'endorsements' | 'reporting' | 'documents';

export const POLICY_SECTIONS: ReadonlyArray<{ section: PolicySection; label: string; path: string }> = [
  { section: 'details', label: 'Policy Details', path: '' },
  { section: 'endorsements', label: 'Endorsements', path: '/endorsements' },
  { section: 'reporting', label: 'Reporting', path: '/reporting' },
  { section: 'documents', label: 'Documents', path: '/documents' },
];

/** A section's URL for one policy. */
export const sectionUrl = (policyId: string | number, path: string) => `/policies/${policyId}${path}`;
